import { AfterViewInit, Component, Inject, Input } from '@angular/core';
//import { SimpleModalComponent } from "ngx-simple-modal";
import { take, map } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmModel {
  title: string;
  fechas: FechaModel[];
  textTimer: number;
}

export interface FechaModel {
  Mes: number;
  Periodo: number;
  MesNombre: string;
}

export interface AdvertenciaResponseModel {
  confirm: boolean;
}

@Component({
  selector: 'app-list-dates',
  templateUrl: './list-dates.component.html',
  styleUrls: ['./list-dates.component.scss']
})
export class ListDatesComponent implements AfterViewInit {
  @Input() title: string = "";
  @Input() fechas: FechaModel[] = [];
  @Input() textTimer: number = 0;
  
  confirmData: ConfirmModel = {
    title: "",
    fechas: [],
    textTimer: 0
  };
  
  // timer: Observable<number>;
  public counter$: Observable<number> = new Observable;

  public counter = 0;

  constructor(public dialogRef: MatDialogRef<ListDatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel,) {
      this.confirmData = data;

      timer(0, 1000).pipe(
        // Take values until the specified duration is reached
        take(this.confirmData.textTimer + 1),
        // Subtract the emitted values from the duration to get the countdown
        map((value) => this.confirmData.textTimer - value)
      ).subscribe((counter) => {
        this.counter = counter;

        // Close the dialog when the countdown reaches zero
        if (counter === 0) {
          // this.close();
        }
      });
  }

  //confirm
  /*confirm() {
    // we set modal result as true on click on confirm button,
    // then we can get modal result from caller code
    // this.result = true;
    // this.close();
    this.dialogRef.close(true);
  }*/

  //cancel
  cerrar() {
    this.dialogRef.close({ confirm: false });
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.confirmData.textTimer > 0) {
      this.counter$ = await timer(0, 1000).pipe(
        take(this.textTimer),
        map(() => {
          return --this.textTimer
        }));
    }
  }

}
